import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { MultiValuesChip } from "../common/multi-values-chip";
import { sort } from "@utils/sort";
export const sortPredicate = sort();
export function CommunitiesTableConfig({ debouncedSearchKey }) {
    const intl = useIntl();
    const communitiesParams = useMemo(() => {
        return {
            include: ["organization", "dxSettings"],
        };
    }, []);
    const communityRowTransform = useCallback((row) => {
        var _a, _b, _c, _d;
        const decoratedRow = row;
        if (debouncedSearchKey) {
            const searchKey = debouncedSearchKey.toLowerCase();
            if ((_a = row === null || row === void 0 ? void 0 : row._id) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_b = row === null || row === void 0 ? void 0 : row.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchKey))
                return decoratedRow;
            if ((_d = (_c = row.organization) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchKey))
                return decoratedRow;
            return null;
        }
        return decoratedRow;
    }, [debouncedSearchKey]);
    const communitiesColumns = useMemo(() => {
        return [
            //@ts-ignore
            {
                id: "_id",
                label: intl.formatMessage(messages.id),
                sortable: false,
                accessor: "_id",
            },
            {
                id: "name",
                label: intl.formatMessage(messages.communityName),
                sortable: false,
                accessor: "name",
            },
            {
                id: "organization.name",
                label: intl.formatMessage(messages.organizationName),
                sortable: false,
                accessor: "organization.name",
            },
            {
                id: "dxSettingsPMS",
                label: intl.formatMessage(messages.dxSettingPMS),
                sortable: false,
                render: (row) => {
                    var _a, _b;
                    return (React.createElement(MultiValuesChip, { values: (_b = (_a = row.dxSettings) === null || _a === void 0 ? void 0 : _a.filter((dx) => { var _a; return ((_a = dx.dataExchange) === null || _a === void 0 ? void 0 : _a.syncPms) === true; })) === null || _b === void 0 ? void 0 : _b.map((dx) => ({ name: dx.service })) }));
                },
            },
            {
                id: "dxSettingsCRM",
                label: intl.formatMessage(messages.dxSettingCRM),
                sortable: false,
                render: (row) => {
                    var _a, _b;
                    return (React.createElement(MultiValuesChip, { values: (_b = (_a = row.dxSettings) === null || _a === void 0 ? void 0 : _a.filter((dx) => { var _a; return ((_a = dx.dataExchange) === null || _a === void 0 ? void 0 : _a.syncProspect) === true; })) === null || _b === void 0 ? void 0 : _b.map((dx) => ({ name: dx.service })) }));
                },
            },
            {
                id: "dxSettingsILS",
                label: intl.formatMessage(messages.dxSettingILS),
                sortable: false,
                render: (row) => {
                    var _a, _b;
                    return (React.createElement(MultiValuesChip, { values: (_b = (_a = row.dxSettings) === null || _a === void 0 ? void 0 : _a.filter((dx) => { var _a; return ((_a = dx.dataExchange) === null || _a === void 0 ? void 0 : _a.syncIls) === true; })) === null || _b === void 0 ? void 0 : _b.map((dx) => ({ name: dx.service })) }));
                },
            },
        ];
    }, []);
    return {
        communitiesParams,
        communitiesColumns,
        communityRowTransform,
    };
}
